import { useEffect } from 'react';
import { Uploads } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';
import { UploadsParams } from 'src/pages/reporting/products/uploaded/overview/use-uploads-params';

type Options = {
  params: UploadsParams;
};

export function useUploads({ params }: Options) {
  const uploads = useAxios(
    (axios, signal, params: UploadsParams) =>
      axios.request<Uploads>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/uploads/report`,
        method: 'GET',
        params,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    uploads.execute(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return uploads;
}

export type UploadsRequest = ReturnType<typeof useUploads>;
